export const REDUX_FORM_CHANGE = '@@redux-form/CHANGE'

export const SELECT_ROUTE = 'SELECT_ROUTE'
export const SELECT_SUITE = 'SELECT_SUITE'
export const SELECT_DATE = 'SELECT_DATE'
export const UPDATE_TICKET_COUNT = 'UPDATE_TICKET_COUNT'
export const PARSE_TICKET_COUNT = 'PARSE_TICKET_COUNT'
export const INITIALIZE_CHECKOUT = 'INITIALIZE_CHECKOUT'
export const INITIALIZE_CHECKOUT_REQUEST = 'INITIALIZE_CHECKOUT_REQUEST'
export const INITIALIZE_CHECKOUT_FAILURE = 'INITIALIZE_CHECKOUT_FAILURE'

export const GET_ROUTES_REQUEST = 'GET_ROUTES_REQUEST'
export const GET_ROUTES_FAILURE = 'GET_ROUTES_FAILURE'
export const RECEIVED_ROUTES = 'RECEIVED_ROUTES'
export const GET_ROUTES_SUCCESS = 'GET_ROUTES_SUCCESS'


export const GET_ROUTE_REQUEST = 'GET_ROUTE_REQUEST'
export const GET_ROUTE_FAILURE = 'GET_ROUTE_FAILURE'
export const RECEIVED_ROUTE = 'RECEIVED_ROUTE'
export const GET_ROUTE_SUCCESS = 'GET_ROUTE_SUCCESS'

export const GET_ROUTE_MAP_REQUEST = 'GET_ROUTE_MAP_REQUEST'
export const GET_ROUTE_MAP_FAILURE = 'GET_ROUTE_MAP_FAILURE'
export const RECEIVED_ROUTE_MAP = 'RECEIVED_ROUTE_MAP'
export const GET_ROUTE_MAP_SUCCESS = 'GET_ROUTE_MAP_SUCCESS'


export const SAVE_ORDER_REQUEST = 'SAVE_ORDER_REQUEST'
export const SAVE_ORDER_FAILURE = 'SAVE_ORDER_FAILURE'
export const RECEIVED_SAVE_ORDER = 'RECEIVED_SAVE_ORDER'
export const SAVE_ORDER_SUCCESS = 'SAVE_ORDER_SUCCESS'


export const GET_ORDER_REQUEST = 'GET_ORDER_REQUEST'
export const GET_ORDER_FAILURE = 'GET_ORDER_FAILURE'
export const RECEIVED_ORDER = 'RECEIVED_ORDER'
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS'

export const UPDATE_ORDER_REQUEST = 'UPDATE_ORDER_REQUEST'
export const UPDATE_ORDER_FAILURE = 'UPDATE_ORDER_FAILURE'
export const RECEIVED_UPDATE_ORDER = 'RECEIVED_UPDATE_ORDER'
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS'

export const CALCULATE_ORDER_REQUEST = 'CALCULATE_ORDER_REQUEST'
export const CALCULATE_ORDER_FAILURE = 'CALCULATE_ORDER_FAILURE'
export const RECEIVED_CALCULATE_ORDER = 'RECEIVED_CALCULATE_ORDER'
export const CALCULATE_ORDER_SUCCESS = 'CALCULATE_ORDER_SUCCESS'


export const PAYMENT_ORDER_REQUEST = 'PAYMENT_ORDER_REQUEST'
export const PAYMENT_ORDER_FAILURE = 'PAYMENT_ORDER_FAILURE'
export const RECEIVED_PAYMENT_ORDER = 'RECEIVED_PAYMENT_ORDER'
export const PAYMENT_ORDER_SUCCESS = 'PAYMENT_ORDER_SUCCESS'

export const GET_ORDER_PDF_REQUEST = 'GET_ORDER_PDF_REQUEST'
export const GET_ORDER_PDF_FAILURE = 'GET_ORDER_PDF_FAILURE'
export const RECEIVED_ORDER_PDF = 'RECEIVED_ORDER_PDF'
export const GET_ORDER_PDF_SUCCESS = 'GET_ORDER_PDF_SUCCESS'


export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'
export const RECEIVED_ME = 'RECEIVED_ME'

export const GET_ORDERS_REQUEST = 'GET_ORDERS_REQUEST'
export const GET_ORDERS_FAILURE = 'GET_ORDERS_FAILURE'
export const RECEIVED_ORDERS = 'RECEIVED_ORDERS'
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS'

export const RETURN_ORDER_REQUEST = 'RETURN_ORDER_REQUEST'
export const RETURN_ORDER_FAILURE = 'RETURN_ORDER_FAILURE'
export const RECEIVED_RETURN_ORDER = 'RECEIVED_RETURN_ORDER'
export const RETURN_ORDER_SUCCESS = 'RETURN_ORDER_SUCCESS'

export const FABRIC_CONFIG_REQUEST = 'FABRIC_CONFIG_REQUEST'
export const FABRIC_CONFIG_FAILURE = 'FABRIC_CONFIG_FAILURE'
export const FABRIC_CONFIG_RECEIVED = 'FABRIC_CONFIG_RECEIVED'
export const FABRIC_CONFIG_SUCCESS = 'FABRIC_CONFIG_SUCCESS'
export const FABRIC_CHANGED = 'FABRIC_CHANGED'

export const PRESET_CONFIG_REQUEST = 'PRESET_CONFIG_REQUEST'
export const PRESET_CONFIG_FAILURE = 'PRESET_CONFIG_FAILURE'
export const PRESET_CONFIG_RECEIVED = 'PRESET_CONFIG_RECEIVED'
export const PRESET_CONFIG_SUCCESS = 'PRESET_CONFIG_SUCCESS'
export const PRESET_CHANGED = 'PRESET_CHANGED'

export const buttons_CONFIG_REQUEST = 'buttons_CONFIG_REQUEST'
export const buttons_CONFIG_FAILURE = 'buttons_CONFIG_FAILURE'
export const buttons_CONFIG_RECEIVED = 'buttons_CONFIG_RECEIVED'
export const buttons_CONFIG_SUCCESS = 'buttons_CONFIG_SUCCESS'
export const buttons_CHANGED = 'buttons_CHANGED'
export const BUTTONS_CONFIG_SYNCHRONIZED = 'BUTTONS_CONFIG_SYNCHRONIZED'

export const SEAMS_CONFIG_REQUEST = 'SEAMS_CONFIG_REQUEST'
export const SEAMS_CONFIG_FAILURE = 'SEAMS_CONFIG_FAILURE'
export const SEAMS_CONFIG_RECEIVED = 'SEAMS_CONFIG_RECEIVED'
export const SEAMS_CONFIG_SUCCESS = 'SEAMS_CONFIG_SUCCESS'
export const SEAMS_CHANGED = 'SEAMS_CHANGED'

export const STRINGS_CONFIG_REQUEST = 'STRINGS_CONFIG_REQUEST'
export const STRINGS_CONFIG_FAILURE = 'STRINGS_CONFIG_FAILURE'
export const STRINGS_CONFIG_RECEIVED = 'STRINGS_CONFIG_RECEIVED'
export const STRINGS_CONFIG_SUCCESS = 'STRINGS_CONFIG_SUCCESS'
export const STRINGS_CHANGED = 'STRINGS_CHANGED'

export const ATTR_CONFIG_REQUEST = 'ATTR_CONFIG_REQUEST'
export const ATTR_CONFIG_FAILURE = 'ATTR_CONFIG_FAILURE'
export const ATTR_CONFIG_RECEIVED = 'ATTR_CONFIG_RECEIVED'
export const ATTR_CONFIG_SUCCESS = 'ATTR_CONFIG_SUCCESS'

export const LAYOUT_CONFIG_REQUEST = 'LAYOUT_CONFIG_REQUEST'
export const LAYOUT_CONFIG_FAILURE = 'LAYOUT_CONFIG_FAILURE'
export const LAYOUT_CONFIG_RECEIVED = 'LAYOUT_CONFIG_RECEIVED'
export const LAYOUT_CONFIG_SUCCESS = 'LAYOUT_CONFIG_SUCCESS'

export const IN_STOCK_CONFIG_REQUEST = 'IN_STOCK_CONFIG_REQUEST'
export const IN_STOCK_CONFIG_FAILURE = 'IN_STOCK_CONFIG_FAILURE'
export const IN_STOCK_CONFIG_RECEIVED = 'IN_STOCK_CONFIG_RECEIVED'
export const IN_STOCK_CONFIG_SUCCESS = 'IN_STOCK_CONFIG_SUCCESS'

export const CHECKOUT_CONFIG_REQUEST = 'CHECKOUT_CONFIG_REQUEST'
export const CHECKOUT_CONFIG_FAILURE = 'CHECKOUT_CONFIG_FAILURE'
export const CHECKOUT_CONFIG_RECEIVED = 'CHECKOUT_CONFIG_RECEIVED'
export const CHECKOUT_CONFIG_SUCCESS = 'CHECKOUT_CONFIG_SUCCESS'

export const SIZES_CONFIG_REQUEST = 'SIZES_CONFIG_REQUEST'
export const SIZES_CONFIG_FAILURE = 'SIZES_CONFIG_FAILURE'
export const SIZES_CONFIG_RECEIVED = 'SIZES_CONFIG_RECEIVED'
export const SIZES_CONFIG_SUCCESS = 'SIZES_CONFIG_SUCCESS'

export const RENDER_CONFIG_REQUEST = 'RENDER_CONFIG_REQUEST'
export const RENDER_CONFIG_FAILURE = 'RENDER_CONFIG_FAILURE'
export const RENDER_CONFIG_RECEIVED = 'RENDER_CONFIG_RECEIVED'
export const RENDER_CONFIG_SUCCESS = 'RENDER_CONFIG_SUCCESS'

export const SET_VIEWED_TAB = 'SET_VIEWED_TAB'
export const INFO_BUTTON_CLICKED = 'INFO_BUTTON_CLICKED'
export const FABRIC_PREVIEW_SETTED = 'FABRIC_PREVIEW_SETTED'
export const ZOOM_BUTTON_CLICKED = 'ZOOM_BUTTON_CLICKED'
export const IMAGES_LOADING = 'IMAGES_LOADING'

export const SIZES_METRICS_REQUEST = 'SIZES_METRICS_REQUEST'
export const SIZES_METRICS_FAILURE = 'SIZES_METRICS_FAILURE'
export const SIZES_METRICS_RECEIVED = 'SIZES_METRICS_RECEIVED'
export const SIZES_METRICS_SUCCESS = 'SIZES_METRICS_SUCCESS'

export const SIZES_FORM_SUBMITTED = 'SIZES_FORM_SUBMITTED'
export const SIZE_ATTR_SELECTED = 'SIZE_ATTR_SELECTED'

export const FABRIC_CHANGE = 'FABRIC_CHANGE'
export const buttons_CHANGE = 'buttons_CHANGE'
export const DETAIL_CHANGE = 'DETAIL_CHANGE'
export const CONTRAST_CHANGE = 'CONTRAST_CHANGE'

export const TOGGLE_FILTER_MENU = 'TOGGLE_FILTER_MENU'
export const TOGGLE_SIZE_SNACK = 'TOGGLE_SIZE_SNACK'
export const APPLY_FABRIC_FILTER = 'APPLY_FABRIC_FILTER'
export const APPLY_DETAIL_PRESET = 'APPLY_DETAIL_PRESET'
export const RECEIVED_DETAIL_PRESET = 'RECEIVED_DETAIL_PRESET'
export const CLEAN_FABRIC_FILTER = 'CLEAN_FABRIC_FILTER'
export const SHIRT_DETAILS_REQUEST_FAIL = 'SHIRT_DETAILS_REQUEST_FAIL'
export const SET_BUILDER_PAGE = 'SET_BUILDER_PAGE'
export const INIT_SEARCH = 'INIT_SEARCH'
export const CATALOG_PRODUCT_OPENED = 'CATALOG_PRODUCT_OPENED'


export const UPDATE_PRODUCT_BY_FABRIC = 'UPDATE_PRODUCT_BY_FABRIC'
export const UPDATE_PRODUCT_BY_CONTRAST = 'UPDATE_PRODUCT_BY_CONTRAST'
export const UPDATE_PRODUCT_BY_CONTRAST_TYPE = 'UPDATE_PRODUCT_BY_CONTRAST_TYPE'
export const UPDATE_PRODUCT_BY_DETAIL = 'UPDATE_PRODUCT_BY_DETAIL'
export const UPDATE_PRODUCT_BY_BUTTON = 'UPDATE_PRODUCT_BY_BUTTON'

export const UPDATE_SELECTED_DETAIL = 'UPDATE_SELECTED_DETAIL'
export const UPDATE_SELECTED_FABRIC = 'UPDATE_SELECTED_FABRIC'
export const UPDATE_SELECTED_BUTTON = 'UPDATE_SELECTED_BUTTON'
export const UPDATE_SELECTED_CONTRAST = 'UPDATE_SELECTED_CONTRAST'

export const UPDATE_SHIRT_RENDER = 'UPDATE_SHIRT_RENDER'

export const UPDATE_SHIRT_PRICE = 'UPDATE_SHIRT_PRICE'
export const UPDATE_SHIRT_PRICE_BY_ATTR = 'UPDATE_SHIRT_PRICE_BY_ATTR'
export const UPDATE_SHIRT_PRICE_BY_FABRIC = 'UPDATE_SHIRT_PRICE_BY_FABRIC'
export const UPDATE_SHIRT_PRICE_BY_CONTRAST = 'UPDATE_SHIRT_PRICE_BY_CONTRAST'
export const UPDATE_SHIRT_PRICE_BY_BUTTONS = 'UPDATE_SHIRT_PRICE_BY_BUTTONS'
export const SET_DETAIL_VIEWED_TAB = 'SET_DETAIL_VIEWED_TAB'